import * as React from 'react'

import { 
   initialState,
   invoiceReducer 
} from './reducer'

const InvoiceContext = React.createContext()

export function useInvoice() {
   const context = React.useContext(InvoiceContext)
   if (context === undefined) {
      throw new Error(`Can't use "useInvoice" without an InvoiceProvider!`);
   }
   return context
}

export function InvoiceProvider({ children }) {
   const [state, dispatch] = React.useReducer(invoiceReducer, initialState);

   return (
      <InvoiceContext.Provider value={{ state, dispatch }}>
         {children}
      </InvoiceContext.Provider>
   )
}